<div class="header">
    <h2>{{ 'predefinedPathways.courses.dialog.title' | translate }}</h2>
</div>

<div class="content">
    <p-table
        data-test="dialog-select-course-table"
        [value]="items()"
        [loading]="loading() ?? false"
        [selectionMode]="'single'"
        (onRowSelect)="selectCourse($event.data)"
        [lazy]="true"
        [paginator]="true"
        [rows]="limit"
        [totalRecords]="total()"
        (onLazyLoad)="onPageChange($event)"
        dataKey="id"
    >
        <ng-template #header>
            <tr>
                <th>{{ 'predefinedPathways.courses.dialog.table.name' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr [pSelectableRow]="item" [attr.data-test]="'dialog-select-course-row-' + item.id">
                <td>{{ item.name }}</td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td class="empty">{{ 'predefinedPathways.courses.dialog.empty' | translate }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
